import { render, staticRenderFns } from "./shouxie.vue?vue&type=template&id=13f18664"
import script from "./shouxie.vue?vue&type=script&lang=js"
export * from "./shouxie.vue?vue&type=script&lang=js"
import style0 from "./shouxie.vue?vue&type=style&index=0&id=13f18664&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.11.0_vue-template-compiler@2.7.16_webpack@5.96.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports